import React, { useState, useEffect } from "react";
import MaskedInput from "react-text-mask";
import { toast } from "react-toastify";
import Bunexe_service from "../../Bunexe_service";

const ResultatBac = () => {
  const [matricule, setMatricule] = useState("");
  const [info, setInfo] = useState(null);
  const [mention, setMention] = useState(null);
  const [startLoading, setStartLoading] = useState(false);
  const [nbVerification, setNbVerification] = useState(0);
  const [donnees, setDonnees] = useState([]);

  const url_ = Bunexe_service.url;

  const setFocus = (champId) => {
    const el = document.getElementById(champId);
    if (el) el.focus();
  };

  const getNbVerification = async () => {
    try {
      const response = await fetch(
        `${url_}/saisie_notes_bac/resultatbac/verification`,
      );
      const data = await response.json();
      setNbVerification(parseInt(data?.nb_verifications || 0, 10));
    } catch (error) {
      console.error("Erreur récupération vérifications:", error);
    }
  };

  const fetchResultat = async (endpointPath, requiredLength) => {
    const cleanMatricule = matricule.trim();
    // const path = "/saisie_notes_bac/resultatbac/8";
    const lastIndex = endpointPath.lastIndexOf("/");

    const before = endpointPath.substring(0, lastIndex);
    const after = endpointPath.substring(lastIndex + 1);
    const finalUrl = `${url_}${before}/${cleanMatricule}/${after}`;
    // console.log("Endpoint Path:", endpointPath);
    // console.log("Before:", before);
    // console.log("After:", after);
    // console.log("Final URL:", finalUrl);

    if (cleanMatricule.length !== requiredLength) {
      toast.error(
        `Il faut saisir un matricule comportant ${requiredLength} chiffres`,
      );
      setFocus("Mat");
      return;
    }

    setStartLoading(true);
    try {
      const response = await fetch(finalUrl);
      const data = await response.json();

      if (data.erreur) {
        toast.error(data.msg || "Aucun résultat trouvé.");
        setFocus("Mat");
      } else {
        setInfo(data.info || null);
        setDonnees(Array.isArray(data.data) ? data.data : []);
        setMention(data.mention || null);
        setMatricule("");
        getNbVerification();
      }
    } catch (error) {
      console.error("Erreur lors de la recherche:", error);
      toast.error("Erreur de connexion au serveur.");
    } finally {
      setStartLoading(false);
    }
  };

  useEffect(() => {
    setFocus("Mat");
    getNbVerification();
  }, []);

  return (
    <div className="row mt-4 mx-1">
      <div className="col-sm-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <div className="row mx-1">
          <p
            className="mb-1 text-center font-weight-bold font-italic w-100"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "12px",
              letterSpacing: "1.8px",
            }}
          >
            Résultat du Bac Haïtien Juillet 2026
          </p>
          <div className="text-center w-100">
            <span className="badge badge-pill badge-dark py-1 px-3 mx-1">
              {nbVerification}
            </span>
            <span
              style={{
                fontSize: "10px",
                fontStyle: "italic",
                fontWeight: "bold",
                fontFamily: "Georgia, serif",
              }}
            >
              Vérification(s)
            </span>
          </div>

          <div className="border border-warning rounded-lg d-flex mt-2 p-1 w-100">
            <div className="form-group m-2 w-100">
              <MaskedInput
                mask={[
                  /0|1/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                className="form-control text-center font-weight-bold"
                placeholder="Matricule ici"
                value={matricule}
                name="Mat"
                id="Mat"
                guide={false}
                style={{ fontSize: "22px", letterSpacing: "2px" }}
                onFocus={() => {
                  setDonnees([]);
                  setInfo(null);
                  setMention(null);
                }}
                onChange={(e) => setMatricule(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="row mt-2">
          {/* <div className="col-12 d-flex justify-content-between flex-wrap"> */}
          <div className="col-12 d-flex flex-wrap justify-content-center align-items-center gap-1 my-2">
            <div className="justify-content-center ">
              <button
                type="button"
                className="btn btn-success btn-sm mb-1 mx-1"
                onClick={() =>
                  fetchResultat("/saisie_notes_bac/resultatbac/8", 10)
                }
              >
                Bac Unique
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm mb-1 mx-1"
                onClick={() =>
                  fetchResultat("/saisie_notes_bac/resultatbac/7", 10)
                }
              >
                Perm. NS4
              </button>
              <button
                type="button"
                className="btn btn-warning btn-sm mb-1 mx-1 "
                onClick={() =>
                  fetchResultat("/saisie_notes_bac/resultatbac/2", 10)
                }
              >
                Perm. Philo
              </button>
              <button
                type="button"
                className="btn btn-danger btn-sm mb-1 mx-1"
                onClick={() =>
                  fetchResultat("/saisie_notes_bac/resultat_9af/9", 8)
                }
              >
                9ème A.F
              </button>
            </div>
          </div>
        </div>

        {startLoading && (
          <div className="row mt-3">
            <div className="col-12 text-center">
              <h4>Patientez ....</h4>
            </div>
          </div>
        )}

        {donnees.length > 0 && !startLoading && info && (
          <div className="card mt-3">
            <div className="card-header text-center">
              <span className="font-weight-bold">
                {info.Nom} {info.Prenom}
              </span>
              {" - "}
              <span className="font-italic">{info.Matricule}</span>
            </div>
            <div className="card-body p-2">
              <table className="table table-sm text-center">
                <thead>
                  <tr>
                    <th scope="col">Matière</th>
                    <th scope="col">Note</th>
                    <th scope="col">Coefficient</th>
                  </tr>
                </thead>
                <tbody>
                  {donnees.map((d, index) => {
                    const isEchec =
                      parseFloat(d.Note_Finale) < parseFloat(d.Coefficient) / 2;
                    return (
                      <tr
                        key={index}
                        className={
                          isEchec ? "text-danger font-weight-bold" : ""
                        }
                      >
                        <td className="font-weight-bold text-left italic">
                          {d.Libelle_Matiere}
                        </td>
                        <td>{d.Note_Finale}</td>
                        <td>{d.Coefficient}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {mention && (
              <div className="card-footer text-center">
                <h6 className="font-weight-bolder mb-0">
                  {mention.Tot} sur {mention.TotCoef} — Mention :{" "}
                  {mention.Mention}
                </h6>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultatBac;
